export default "__VITE_ASSET__CFVEB0Cw__"